"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRouterDom = require("react-router-dom");
var _react = _interopRequireDefault(require("react"));
var _pagerButton = _interopRequireDefault(require("../../core/pager-button"));
var _navTabs = _interopRequireDefault(require("../../core/nav-tabs"));
var _link = _interopRequireDefault(require("../../core/link"));
var _userIsCalendarOfficer = _interopRequireDefault(require("../../../schema/security/user-is-calendar-officer"));
var _userIsSystemAdmin = _interopRequireDefault(require("../../../schema/security/user-is-system-admin"));
var _requireAuthentication = _interopRequireDefault(require("../../require-authentication"));
var _notFound = _interopRequireDefault(require("../../not-found"));
var _calendar = _interopRequireDefault(require("./calendar"));
var _calendarControls = _interopRequireDefault(require("./calendar-controls"));
var _applicationEdit = _interopRequireDefault(require("./application-edit"));
var _applicationChange = _interopRequireDefault(require("./application-change"));
var _myApplications = _interopRequireDefault(require("./my-applications"));
var _yearBook = _interopRequireDefault(require("./year-book"));
var _contactEmails = _interopRequireDefault(require("./contact-emails"));
var _help = _interopRequireDefault(require("./help"));
var _constantParams = require("../../../constant-params");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _notFound.default
});
function CalendarApplications({
  isAuthenticated,
  user,
  loaded,
  match: {
    url,
    path,
    params
  },
  location: {
    pathname
  }
}) {
  const previousYear = +params.yearID - 1;
  const previousYearURL = pathname.replace('year/' + params.yearID, 'year/' + previousYear);
  const nextYear = +params.yearID + 1;
  const nextYearURL = pathname.replace('year/' + params.yearID, 'year/' + nextYear);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "span"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pull-xs-left"
  }, previousYear < 2020 ? null : /*#__PURE__*/_react.default.createElement(_pagerButton.default, {
    to: previousYearURL
  }, "Previous Year ", previousYear)), /*#__PURE__*/_react.default.createElement("div", {
    className: "pull-xs-right"
  }, nextYear > _constantParams.thisYear + 1 ? null : /*#__PURE__*/_react.default.createElement(_pagerButton.default, {
    to: nextYearURL
  }, "Next Year ", nextYear)), /*#__PURE__*/_react.default.createElement("h1", {
    className: "text-primary text-xs-center"
  }, "Calendar Applications for ", params.yearID)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_navTabs.default, null, /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/calendar'
  }, "Calendar")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/my-applications'
  }, "My Applications")), !isAuthenticated || !(0, _userIsSystemAdmin.default)(user) ? null : [/*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "controls"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/calendar-controls'
  }, "Calendar Controls"))], !isAuthenticated || !(0, _userIsCalendarOfficer.default)(user) ? null : [/*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "year-book"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/year-book'
  }, "Year Book")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "contacts"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/contact-emails'
  }, "Contacts"))], /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/help'
  }, "Help"))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: 14
    }
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: path,
    to: url + '/calendar'
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/calendar',
    component: _calendar.default,
    fullWidth: true
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/my-applications',
    component: _myApplications.default,
    fullWidth: true
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/year-book',
    component: _yearBook.default,
    fullWidth: true
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: false,
    path: path + '/application-edit/:appid',
    component: _applicationEdit.default,
    fullwidth: true
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: false,
    path: path + '/application-change/:appid',
    component: _applicationChange.default,
    fullwidth: true
  }), !isAuthenticated || !(0, _userIsCalendarOfficer.default)(user) ? null : [/*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/calendar-controls',
    component: _calendarControls.default,
    key: "controls-route"
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/contact-emails',
    component: _contactEmails.default,
    key: "contacts-route"
  })], /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/help',
    component: _help.default,
    fullWidth: true
  }), _ref))));
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _requireAuthentication.default)(CalendarApplications);